<template>
  <o-form-wrapper
    v-model="item"
    :server-errors="_se"
    :v="$v.item"
    :schema="schema"
    :form-state="formState"
  >
    <o-widget-wrapper
      :schema="schema"
      name="name"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-text-field
        v-model="item.name"
        :form-state="formState"
        name="name"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.name"
      ></o-text-field>
    </o-widget-wrapper>
    <o-widget-wrapper
      :schema="schema"
      name="type"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-select
        v-model="item.type"
        :items="codeStateTypeItems"
        text-field="description"
        value-field="id"
        sort-field="description"
        :form-state="formState"
        name="type"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.type"
        store-name="CodeStateType"
      >
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper
      :schema="schema"
      name="details"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <o-textarea
        v-model="item.details"
        :form-state="formState"
        name="details"
        :validators="$v.item"
        :server-errors="_se"
        v-bind="schema.fields.details"
      ></o-textarea>
    </o-widget-wrapper>

    <o-widget-wrapper
      class="mb-3"
      :schema="schema"
      name="activities"
      :validators="$v.item"
      :server-errors="_se"
      :form-state="formState"
    >
      <process-activity-form-cards
        :codeActivityTypeItems="codeActivityTypeItems"
        :item-roles="itemRoles"
        v-model="item.activities"
        :validators="$v.item.activities"
        :form-state="formState"
        :label="schema.fields.activities.label"
        :level="level + 1"
        :server-errors="_se.activities"
      >
      </process-activity-form-cards>

      <!-- UNCOMMENT TO USE Cards
<process-activity-form-cards v-model="item.activities"
    :validators="$v.item.activities"
    :form-state="formState"
    :label="schema.fields.activities.label"
    :level="level+1"
    :server-errors="_se.activities">
</process-activity-form-cards>
-->
    </o-widget-wrapper>
  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin,
} from "../../../../vue-ocom/mixins";
import { validationMixin } from "vuelidate";
import OWidgetWrapper from "../../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../../vue-ocom/components/forms/fields/ODateTime";
import OTextarea from "../../../../vue-ocom/components/forms/fields/OTextarea";

import { default as CodeStateTypeForm } from "../../code_state_type/components/ItemForm";
import { default as ProcessForm } from "../../process/components/ItemForm";
// import { default as ProcessActivityFormTable } from "../../process_activity/components/ItemFormTable";
import { default as ProcessActivityFormCards } from "../../process_activity/components/ItemFormCards";

export default {
  mixins: [
    VuelidateMixin,
    validationMixin,
    CreateFormStateMixin("$v"),
    CreateGroupPermissionMixin("ProcessState"),
    CreateCodeTableFetchMixin([]),
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,
    OTextarea,

    CodeStateTypeForm,
    ProcessForm,
    // ProcessActivityFormTable,
    ProcessActivityFormCards,
  },
  props: {
    codeStateTypeItems: { type: Array, default: () => [] },
    codeActivityTypeItems: { type: Array, default: () => [] },
    itemRoles: { type: Array, default: () => [] },
    item: { type: Object, default: () => {} },
    level: { type: Number, default: 0 },
    inModal: { type: Boolean, default: false },
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.ProcessState, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    },
  },
  watch: {},
  created() {},
};
</script>
